import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/i18n";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Properties from "@/components/site/Properties";
import Testimonials from "@/components/site/Testimonials";
import InstagramRow from "@/components/site/InstagramRow";
import VideoSection from "@/components/site/VideoSection";
import Faq from "@/components/site/Faq";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import ProjectDetail from "@/components/site/ProjectDetail";

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <About />
      <Properties />
      <Testimonials />
      <InstagramRow />
      <VideoSection />
      <Faq />
      <Contact />
    </main>
    <Footer />
  </>
);

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-charcoal font-sans text-[#FAFAFA] antialiased overflow-x-hidden">
          <div className="grain" aria-hidden="true" />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/project/:id" element={<ProjectDetail />} />
          </Routes>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: { background: "#111111", border: "1px solid rgba(218,165,32,0.4)", color: "#FAFAFA" },
            }}
          />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}
